(function() {
  if (customElements.get('flash-promo-timer')) return;

  class FlashPromoTimer extends HTMLElement {
    connectedCallback() {
      this.start = this.parseDate(this.dataset.start);
      this.end = this.parseDate(this.dataset.end);
      if (!this.start || !this.end || this.start >= this.end) return;

      this.hoursEl = this.querySelector('[data-role="hours"]');
      this.minutesEl = this.querySelector('[data-role="minutes"]');
      this.secondsEl = this.querySelector('[data-role="seconds"]');

      this.tick();
      this.intervalId = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) clearInterval(this.intervalId);
    }

    parseDate(str) {
      if (!str) return null;
      const normalized = String(str).replace(/([+-])(\d{2})(\d{2})$/, '$1$2:$3');
      const d = new Date(normalized);
      return isNaN(d.getTime()) ? null : d;
    }

    tick() {
      const now = new Date();
      if (now < this.start || now >= this.end) {
        this.dataset.state = 'hidden';
        return;
      }
      this.dataset.state = 'active';
      this.update(this.end - now);
    }

    update(ms) {
      if (ms < 0) ms = 0;
      const totalSec = Math.floor(ms / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      this.hoursEl.textContent = pad(Math.floor(totalSec / 3600));
      this.minutesEl.textContent = pad(Math.floor((totalSec % 3600) / 60));
      this.secondsEl.textContent = pad(totalSec % 60);
    }
  }

  customElements.define('flash-promo-timer', FlashPromoTimer);
})();